module.exports = __webpack_public_path__ + "static/24-18f0f6c623de90edea8f2b321a81fceb.png";